<signup-success-verification-form
  (navigateToLogin)="navigateToLogin()"
  [appName]="appName"
></signup-success-verification-form>